import audioUnlock from '@aneutralgiraffe/audio-unlock';
import '../../../beardman-header/src/js';

document.addEventListener('DOMContentLoaded', () => audioUnlock());

let startX;
let startY;

// Clear grid item selected classes when returning to the page via the back button
window.addEventListener('pageshow', () => {
  const elGrid = document.querySelector('.grid');
  const elSelectedGridItem = document.querySelector('a.selected');

  if (elSelectedGridItem) {
    elSelectedGridItem.classList.remove('selected');
  }

  elGrid.classList.remove('game-selected');
});

document.addEventListener('DOMContentLoaded', () => {
  const elGrid = document.querySelector('.grid');
  const elSelectedGridItem = document.querySelector('a.selected');

  if (elSelectedGridItem) {
    elSelectedGridItem.classList.remove('selected');
  }

  elGrid.classList.remove('game-selected');

  function loadGame(event) {
    event.preventDefault();

    if (event.target.matches('a')) {
      event.preventDefault();
      event.target.classList.toggle('selected');

      elGrid.classList.toggle('game-selected');

      setTimeout(() => {
        window.location.href = event.target.href;
      }, 800);
    }
  }

  elGrid.addEventListener('click', loadGame);

  document.addEventListener('touchstart', (event) => {
    const touch = event.changedTouches[0];

    startX = touch.pageX;
    startY = touch.pageY;
  });

  document.addEventListener('touchend', (event) => {
    const touch = event.changedTouches[0];

    if (
      event.target.tagName === 'A' &&
      (Math.abs(startX - touch.pageX) + Math.abs(startY - touch.pageY)) < 4
    ) {
      loadGame(event);
    }
  });
});
